<template>
  <div class="modal">
    <centered-container horizontal="center">
      <div class="loader-container">
        <app-loader class="loader" />
        <span>Loading...</span>
      </div>
    </centered-container>
  </div>
</template>

<script>
import appLoader from "./app-loader";
export default {
  name: "app-loading",
  components: {
    "app-loader": appLoader
  }
};
</script>

<style scoped lang="scss">
.loader {
  transform: scale(.32);
  display: flex;
  position: absolute;
}

.loader-container {
  height: 1.8rem;
  width: fit-content;
  margin: auto;
}

.modal {
  color: #222;
  display: table-cell;
  position: fixed;
  z-index: 10000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: $modal-two-color;

  span {
    margin-left: 2.0rem;
    font-size: 0.9rem;
  }
}
</style>